import { render, staticRenderFns } from "./Rooms.vue?vue&type=template&id=4f12bb5a&scoped=true&"
import script from "./Rooms.vue?vue&type=script&lang=ts&"
export * from "./Rooms.vue?vue&type=script&lang=ts&"
import style0 from "./Rooms.vue?vue&type=style&index=0&id=4f12bb5a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f12bb5a",
  null
  
)

export default component.exports